export { default } from "./PlayerNewsCard";
